import { useEffect } from 'react'

export interface TermsAndConditionsProps {}

export const useTermsAndConditions = (props: TermsAndConditionsProps) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return {
    ...props,
  }
}
